import React from "react";
import classNames from "classnames";
import { PagedResources } from "@common/pagedResources";
import { Props } from "./types";
import { Resource } from "./resource";
import { SearchInput } from "./searchInput";
import styles from "./styles.scss";

// Every planzone resource, or only the project members, searched and paginated by the back.
const QuickAllocationMenu = React.forwardRef(
  (
    {
      filters = [],
      className,
      style,
      project,
      autoFocus,
      selectResource,
      hide,
    }: Props,
    forwardedRef: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const [filter, setFilter] = React.useState("");

    return (
      <div
        ref={forwardedRef}
        className={classNames(styles.quickAllocationMenu, {
          [`${className}`]: !!className,
        })}
        style={style}
      >
        <div className={styles.search}>
          <SearchInput
            autoFocus={autoFocus}
            filter={filter}
            search={setFilter}
          />
        </div>
        <PagedResources
          flagName="quickAllocationFlag"
          search={filter}
          project={project?.uuid ? project : undefined}
          className={styles.resourcesList}
        >
          {(resources) =>
            resources
              .filter(
                ({ uuid }) =>
                  !filters.find((resource) => resource.uuid === uuid),
              )
              .map((resource) => (
                <div
                  key={resource.uuid}
                  className={styles.item}
                  onClick={(e) => {
                    if (hide) hide();
                    e.stopPropagation();
                    selectResource(resource);
                  }}
                >
                  <Resource resource={resource} />
                </div>
              ))
          }
        </PagedResources>
      </div>
    );
  },
);

export { QuickAllocationMenu };
